module.exports = __webpack_public_path__ + "img/SI5103061.945ce0e7.png";